// import React from 'react'

// const PlayIcon = () => {
//   return (
//       <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M9 17.125C7.39303 17.125 5.82214 16.6485 4.486 15.7557C3.14985 14.8629 2.10844 13.594 1.49348 12.1093C0.87852 10.6247 0.717618 8.99099 1.03112 7.4149C1.34463 5.8388 2.11846 4.39106 3.25476 3.25476C4.39106 2.11846 5.8388 1.34463 7.4149 1.03112C8.99099 0.717618 10.6247 0.87852 12.1093 1.49348C13.594 2.10844 14.8629 3.14985 15.7557 4.486C16.6485 5.82214 17.125 7.39303 17.125 9C17.125 11.1549 16.269 13.2215 14.7452 14.7452C13.2215 16.269 11.1549 17.125 9 17.125ZM9 2.125C7.64026 2.125 6.31105 2.52822 5.18046 3.28365C4.04987 4.03908 3.16868 5.11281 2.64833 6.36906C2.12798 7.6253 1.99183 9.00763 2.2571 10.3412C2.52238 11.6749 3.17716 12.8999 4.13864 13.8614C5.10013 14.8228 6.32514 15.4776 7.65876 15.7429C8.99238 16.0082 10.3747 15.872 11.631 15.3517C12.8872 14.8313 13.9609 13.9501 14.7164 12.8195C15.4718 11.689 15.875 10.3597 15.875 9C15.875 7.17664 15.1507 5.42796 13.8614 4.13864C12.5721 2.84933 10.8234 2.125 9 2.125ZM7.97875 12.03C7.88541 12.092 7.77582 12.1251 7.66375 12.125C7.59548 12.1278 7.52731 12.1171 7.4632 12.0935C7.39908 12.0699 7.34028 12.0338 7.29019 11.9873C7.2401 11.9408 7.19972 11.8848 7.17136 11.8227C7.14301 11.7605 7.12726 11.6933 7.125 11.625V6.375C7.12559 6.26918 7.16169 6.16662 7.2275 6.08375C7.3173 5.97663 7.44341 5.90632 7.58175 5.88627C7.72009 5.86621 7.86097 5.8978 7.9775 5.975L11.9025 8.6C11.9501 8.62931 11.9924 8.66651 12.0275 8.71C12.0685 8.76222 12.0979 8.82251 12.1139 8.88692C12.1298 8.95133 12.132 9.01839 12.1202 9.08369C12.1084 9.14899 12.0829 9.21105 12.0453 9.26578C12.0078 9.32052 11.9591 9.36669 11.9025 9.40125L7.97875 12.03Z" fill="#B3B3B3"/>
//       </svg>
//   )
// }

// export default PlayIcon



import React from "react";

const PlayIcon = ({ disabled = false }) => {
  return disabled ? (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g >
        <rect x="2" y="1" width="40" height="40" rx="16" fill="#EBEBED" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 14.6531C14.5 13.2269 16.029 12.3229 17.2786 13.0102L28.8192 19.3575C30.1144 20.0698 30.1144 21.9309 28.8192 22.6433L17.2786 28.9906C16.029 29.6779 14.5 28.7738 14.5 27.3477V14.6531Z"
          fill="#F6F6F6"
        />
      </g>

      <defs>
        <filter
          id="filter0_dd_411_28318"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28318" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow_411_28318" result="effect2_dropShadow_411_28318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28318" result="shape" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect x="2" y="1" width="40" height="40" rx="16" fill="#52CBC4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 14.6531C14.5 13.2269 16.029 12.3229 17.2786 13.0102L28.8192 19.3575C30.1144 20.0698 30.1144 21.9309 28.8192 22.6433L17.2786 28.9906C16.029 29.6779 14.5 28.7738 14.5 27.3477V14.6531Z"
          fill="white"
        />
      </g>

      <defs>
        <filter
          id="filter0_dd_411_30790"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_30790" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow_411_30790" result="effect2_dropShadow_411_30790" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_30790" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default PlayIcon;